import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
// helpers
import get from 'lodash.get';

function PdpSharedDetailWeight({ item }) {
    const weightValue = get(item, 'measurement.weight.value');
    const weightUnit = get(item, 'measurement.weight.unit');

    if (!weightValue) {
        return null;
    }

    return (
        <span data-tn="pdp-spec-weight">
            {weightValue} {weightUnit}
        </span>
    );
}

PdpSharedDetailWeight.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailWeight, {
    item: graphql`
        fragment PdpSharedDetailWeight_item on Item {
            measurement {
                weight {
                    unit
                    value
                }
            }
        }
    `,
});
